import type { FailDeliveryCharacterId } from './character_icon/CharacterIcon';

export type FailDeliveryScreenProps = {
  characterId?: FailDeliveryCharacterId;
  onRestart?: () => void;
  onGoHome?: () => void;
  restartCost?: number;
  canRestart?: boolean;
};

export type FailDeliveryScreenModel = {
  characterId: FailDeliveryCharacterId;
  onRestart?: () => void;
  onGoHome?: () => void;
  restartCost?: number;
  canRestart: boolean;
};

export function createFailDeliveryScreenModel(
  props: FailDeliveryScreenProps,
): FailDeliveryScreenModel {
  return {
    characterId: props.characterId ?? 'rock',
    onRestart: props.onRestart,
    onGoHome: props.onGoHome,
    restartCost: props.restartCost,
    canRestart: props.canRestart !== false,
  };
}
